// import time from "../../../src/IMAGES/time.png";
class searchView {
  _search = document.querySelector(".search");
  _input = document.querySelector("#search");
  _btn = document.querySelector(".searchBtn");
  _latest = document.querySelector(".latest_post");
  _l_post = document.querySelector(".post");
  body = document.querySelector("body");
  error = document.querySelector(".error");

  _addHandler(handler, returned) {
    this.body.addEventListener("click", function (e) {
      const target = e.target.closest(".searchBtn");

      if (!target) return;

      const data = document.querySelector("#search").value;
      if (data === "") return;

      handler(data, returned);
    });
  }
  _addSpinner() {
    const markup = `
    <div class="loadingio-spinner-spinner-h816jufu83l">
    <div class="ldio-iihtkgi1l2">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
    `;
    this._latest.innerHTML = "";
    this._latest.insertAdjacentHTML("afterbegin", markup);
  }
  _addSearchResults(data) {
    console.log(data);
    let options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    console.log(data.uid);
    const date = new Intl.DateTimeFormat("en-US", options).format(data.time);
    const markUp = `
    

      <section class="post flex  justify-around mb-4 items-start" data-tab="${
        data.uid
      }">
      <section class="w-6/12 h-fit  img">
      <img class="rounded-xl" src="${data.url}" alt="">
      </section>
      <section class="w-full text ml-2 ">
        <h1 class="font-bold text-sm 2sm:text-xs md:text-xs">${data.title.toUpperCase()}</h1>
        <h1 class=" mt-1 text-xs">${date}</h1>
      </section>
      </section>
      `;

    this._latest.insertAdjacentHTML("afterbegin", markUp);
  }
}

export default new searchView();
